import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DownIcon } from '@/assets';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { RotatableView } from '@/shared/components/animated/RotatableView';
import { OutlinedButton } from '@/shared/components/OutlinedButton';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

// TODO: move to theme
const ICON_SIZE = 18;

type Props = {
  expanded: boolean;
  onChange: (newExpanded: boolean) => void;
};

export const ShowMoreButton: FC<Props> = ({ expanded, onChange }) => {
  const { t } = useTranslation(LocalizationNameSpace.SHARED, {
    keyPrefix: 'showMoreButton'
  });
  const { colors } = useAppTheme();

  return (
    <OutlinedButton
      icon={() => (
        <RotatableView changeRotation={expanded}>
          <DownIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            fill={colors.outline}
          />
        </RotatableView>
      )}
      onPress={() => onChange(!expanded)}
    >
      {t(expanded ? 'showLess' : 'showMore')}
    </OutlinedButton>
  );
};
